import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  color?: string;
}

export const TitleText = styled.h1`
  font-family: ${FONTS.ROBOTO};
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 700;
  ${(props: Props) => props.color && `
    color: ${props.color};
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-family: ${FONTS.MONTSERRAT_BOLD};
  }
`;

export const About = styled.p`
  font-size: 11px;
  line-height: 24px;
  font-family: ${FONTS.OPEN_SANS};
  border-radius: 4px;
  padding: 0px 9px;
  margin: -15px 0 25px 0;
  background: #f0f0f0;
  color: ${COLORS.GRAY_DARK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;
    line-height: 20px;
  }
`;
